// Used only for index page
import { FC } from 'react';
import {
  useSearchParamState,
  serializationOptionsForStringValue,
  createSerializationOptionsForEnumValue,
} from 'utils/hooks/useSearchParamState';
import { ListType } from 'modules/domains/list';
import { FilterContext } from './FilterContext';

export const FilterContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [search, setSearch] = useSearchParamState({
    searchParamKey: 'search',
    stateValueWhenSearchParamIsUnset: '',
    ...serializationOptionsForStringValue,
  });
  const [type, setType] = useSearchParamState({
    searchParamKey: 'type',
    stateValueWhenSearchParamIsUnset: null,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: ListType,
      stateValueWhenSearchParamIsInvalid: null,
    }),
  });

  return (
    <FilterContext.Provider value={{ search, type, setSearch, setType }}>
      {children}
    </FilterContext.Provider>
  );
};
